export default class Category {
  constructor() {
    this.form = document.getElementById('category_update');

    if (this.form) {
      this.validator = window.solodev.formValidators[this.form.id];
      // This is callback called by header button.
      window.solodev.submitForm = () => this.form.submit();
    }
  }
}
